import axios from 'axios';
import * as actionTypes from './types';
import { socket } from '../socket';
import { store } from '../store';
import { updateMilestoneConnectorOrderDB } from './milestonesActions';

export const retrieveMilestoneConnectors = (journeyId) => {
  return (dispatch) => {
    axios
      .get('/api/milestone-connector/journey_id/' + journeyId)
      .then((res) => {
        for (const connector of res.data.milestoneConnectors) {
          dispatch(
            addMilestoneConnector(
              connector.id,
              connector.connector_name,
              connector.title,
              connector.content
            )
          );
          dispatch(
            updateConnectorPersona(
              connector.connector_name,
              connector.id,
              connector.persona_ids || []
            )
          );
          dispatch(
            updateConnectorProduct(
              connector.connector_name,
              connector.id,
              connector.product_ids || []
            )
          );
        }
      })
      .catch((error) => {
        console.log('Milestone Connectors Error: ', error);
      });
  };
};


export const deleteJourneyMilestoneConnectors = (journeyId) => {
  return (dispatch) => {
    axios
      .delete('/api/milestone-connector/journey_id/' + journeyId)
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        console.log(error);
      });
  };
};


export const updateConnectorProductDB = (connectorName, id, products) => async (
  dispatch
) => {
  const { [id]: currentConnector } = store.getState().milestoneConnectors[
    connectorName
  ];
  console.log(currentConnector);
  await axios
    .patch(`/api/milestone-connector/${id}`, {
      connector: { ...currentConnector, productIds: [...products] },
    })
    .then((res) => {
      console.log(res.data);
      dispatch(updateConnectorProduct(connectorName, id, products));
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateConnectorProduct = (connectorName, id, products) => ({
  type: actionTypes.UPDATE_CONNECTOR_PRODUCT,
  connectorName,
  id,
  products,
});

export const updateConnectorPersonaDB = (connectorName, id, personas) => async (
  dispatch
) => {
  const { [id]: currentConnector } = store.getState().milestoneConnectors[
    connectorName
  ];
  console.log(currentConnector);
  await axios
    .patch(`/api/milestone-connector/${id}`, {
      connector: { ...currentConnector, personaIds: [...personas] },
    })
    .then((res) => {
      console.log(res.data);
      dispatch(updateConnectorPersona(connectorName, id, personas));
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateConnectorPersona = (connectorName, id, personas) => ({
  type: actionTypes.UPDATE_CONNECTOR_PERSONA,
  connectorName,
  id,
  personas,
});



/**
 * TODO: ADD MILESTONE CONNECTOR [SOCKET EVENT]
 * @param {integer} journeyId : ID of the journey
 * @param {integer} connectorName : name of the connector stage associated with the idea
 * @param {string} title : the stage the idea is associated with
 * @param {string} ideaContent : the content the ideas has
 */
export const addMilestoneConnectorDBOnly = (journeyId, connectorName, title, content) => {
  return () => {
    socket.emit('onMilestoneConnectorAddServer', { 
      journey_id: journeyId,
      connector_name: connectorName, 
      title: title, 
      content : content, 
    });
  };
};




/**
 * TODO: ADD MILESTONE CONNECTOR [REDUX ACTION]
 * @param {integer} id : ID of the journey
 * @param {integer} connectorName : ID of the persona who created the idea
 * @param {string} title : the stage the idea is associated with
 * @param {string} content : the content the ideas has
 */
export const addMilestoneConnector = (id, connectorName, title, content) => ({
  type: actionTypes.ADD_MILESTONE_CONNECTOR,
  id: id,
  connectorName: connectorName,
  title: title,
  content: content,
});




/**
 * TODO: UPDATE MILESTONE CONNECTOR [SOCKET EVENT]
 * @param {*} connectorName 
 * @param {*} id 
 * @param {*} content 
 */
export const updateMilestoneConnectorDBOnly = (connectorName, id, title, content) => {
  return () => {
    socket.emit('onMilestoneConnectorUpdateServer', { 
      id: id,
      title,
      connectorName: connectorName, 
      content : content, 
    });
  };
};




/**
 * TODO: UPDATE MILESTONE CONNECTOR [REDUX ACTION]
 * @param {*} connectorName: 
 * @param {*} id:
 * @param {*} title:
 * @param {*} content:
 */
export const updateMilestoneConnector = (connectorName, id, title, content) => ({
  type: actionTypes.UPDATE_CONNECTOR_CONTENT,
  connectorName,
  id,
  title,
  content,
});




/**
 * TODO: DELETE MILESTONE CONNECTOR [SOCKET EVENT]
 * @param {*} id 
 * @param {*} connectorName 
 */
export const deleteMilestoneConnectorDBOnly = (id, connectorName) => {
  return () => {
    socket.emit('onMilestoneConnectorDeleteServer', { 
      id: id,
      connector_name: connectorName,
    });
  };
};




/**
 * TODO: DELETE MILESTONE CONNECTOR [REDUX ACTION]
 * @param {id} id:
 * @param {sting} connectorName:
 */
export const deleteMilestoneConnector = (id, connectorName) => ({
  type: actionTypes.DELETE_MILESTONE_CONNECTOR,
  id: id,
  connectorName: connectorName,
});